import {componentConfig, componentLoader} from "../../lib/component_initializer";
import { SignupForm } from "./index";
export const signupFormLoader = function (options = {}) {
    componentLoader(componentConfig(SignupForm, SignupForm.config.componentTypeKey, SignupForm.config.baseHtmlClass), options);
};
